/**
 * Extra drop-in spots a class adds beyond a schedule's capacity (#6326, owner
 * decision 2026-10-26): `classes.extra_drop_ins_allowed` counts only when the
 * class drop-in mode (`drop_in_availability_rule`) is 'extra_slots'. On
 * 'always' or 'only_if_not_full' a number left over from an earlier setting
 * adds nothing.
 *
 * The ONE rule for web and mobile. Web: the enroll route's early check and
 * checkout seat hold, the after-payment enroll, and the booking calendar
 * (gym-admin-dashboard/src/utils/programs/dropInExtraCapacity.ts). Mobile: the
 * spots-taken line (utils/programs/sectionEnrollmentCount.ts). The hold
 * re-check at Pay (hold_enrollment_seats_for_payment, SQL) writes the same CASE.
 */

export interface DropInExtraCapacitySource {
  drop_in_availability_rule?: string | null;
  extra_drop_ins_allowed?: number | null;
}

export function dropInExtraCapacity(classRow: DropInExtraCapacitySource | null | undefined): number {
  if (classRow?.drop_in_availability_rule !== 'extra_slots') return 0;
  const extra = Number(classRow.extra_drop_ins_allowed);
  return Number.isFinite(extra) && extra > 0 ? Math.floor(extra) : 0;
}
